import { IAttachment } from './attachment.model';

export interface IWorkshopVehicleDetails {
  buildDate: Date;
  driver: IDriverOwner;
  franchise: IFranchise;
  make: string;
  model: IModel;
  odometer: IOdometer;
  owner: IDriverOwner;
  registrationNumber: string;
  serviceModelId: string;
  vin: string;
  attachments: IAttachment[];
}

export interface IDriverOwner {
  code: string;
  name: string;
}

export interface IFranchise {
  code: string;
  description: string;
}

export interface IModel {
  code: string;
  name: string;
}

export interface IOdometer {
  reading: number;
  units: string;
}

export interface IUpdateWorkshopVehicleAttachments {
  registrationNumber: string;
  repairOrderNumber: number;
  attachments: IAttachment[];
}

export const ADHOC_REG = '<adhoc>';
